import { render, staticRenderFns } from "./topSalesBySubSeries.vue?vue&type=template&id=07c97a51&scoped=true"
import script from "./topSalesBySubSeries.vue?vue&type=script&lang=js"
export * from "./topSalesBySubSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c97a51",
  null
  
)

export default component.exports